import { Injectable } from "@angular/core";
import { Observable, map, of, retry } from "rxjs";
import { EnvironmentUrlService } from "./environment-url.services";
import { withCache } from '@ngneat/cashew';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Domain, DatasetField, DatasetFieldDto } from "../models";

@Injectable({
  providedIn: "root",
})
export class DomainsService {

  constructor(
    private envUrl: EnvironmentUrlService,
    private http: HttpClient
  ) {
  }

  getDomainDetail(id:number) {
    const url = `${this.envUrl.serverUrl}/v1/domains/${id}`;
    return this.http.get<Domain>(url).pipe(retry(1));
  }
  getDomainCollectionApi() {
    const url = `${this.envUrl.serverUrl}/v1/domains`;
    return this.http.get<Domain[]>(url).pipe(retry(1));
  }
  getSubDomainCollectionApi(domainId: number) {
    const url = `${this.envUrl.serverUrl}/v1/domains/${domainId}/subdomains`;
    return this.http.get<Domain[]>(url).pipe(retry(1));
  }

  getDomainDatasets(domainId: number) {
    const url = `${this.envUrl.serverUrl}/v1/domains/${domainId}/datasets`;
    return this.http.get<Domain[]>(url).pipe(retry(1));
  }

  getControlCollectionStandalone(subdatasetId: number = 1) {
    let collection: DatasetField[] = [
      {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 1,
            dbFieldName: "dbFieldName",
            description: "description",
            uiName: "uiName string",
            uiDescription: "uiDescription",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 50,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 2,
            dbFieldName: "dbFieldName2",
            description: "description2",
            uiName: "uiName int",
            uiDescription: "uiDescription2",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 6,
            dbFieldName: "dbFieldName3",
            description: "description3",
            uiName: "uiName date range",
            uiDescription: "uiDescription3",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 4,
            dbFieldName: "dbFieldName4",
            description: "description4",
            uiName: "uiName date",
            uiDescription: "uiDescription4",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 5,
            dbFieldName: "dbFieldName4",
            description: "description4",
            uiName: "uiName IN string",
            uiDescription: "uiDescription4",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 11,
            dbFieldName: "dbFieldName4",
            description: "description4",
            uiName: "uiName IN number",
            uiDescription: "uiDescription4",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 12,
            dbFieldName: "dbFieldName4",
            description: "description4",
            uiName: "uiName single selection",
            uiDescription: "uiDescription4",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value1",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value2",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value3",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value4",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "value5",
            }],
            userValue: ''
          },
          {
            datasetFieldId: 0,
            datasetId: 0,
            depFilterCodeId: 13,
            dbFieldName: "dbFieldName4",
            description: "description4",
            uiName: "uiName multiple selection",
            uiDescription: "uiDescription4",
            dataType: "dataType",
            mandatoryFilter: false,
            uiFilterHelpText: "uiFilterHelpText",
            maxRange: "maxRange",
            fieldTextLength: 25,
            datasetFieldMultivalues: [{
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "multi-value1",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "multi-value2",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "multi-value3",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "multi-value4",
            },
            {
              dsFldMultivalueId: 0,
              datasetFieldId: 0,
              key: "key",
              value: "multi-value5",
            }
          ],
            userValue: ''
          },
    ];

    return of(collection);
  }

}

export interface IDomainDto {
  DomainId: number;
  ParentDomainId: number;
  Name: string;
  DisplayName: string;
  DisplayDescription: string;
  DisplayUrl: string;
  DisplayUrlName: string;
}


